import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { RegionProvider } from "../../shared/providers/region.provider";
import { Router } from "@angular/router";
import { RouteDataProvider } from "src/app/shared/providers/RouteDataProvider.provider";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { RegionModel } from "../../shared/models/region";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { XlsxViewComponent } from "src/app/shared/xlsx-view/xlsx-view.component";
import { ExcelModel } from "../../shared/models/geography";
import { XlsxService } from "src/app/services/xlsx/xlsx.service";
import { ExportExcelService } from "src/app/shared/xlsx-view/export-excel.service";
import { REGION_UPLOAD_HEADER } from "../../shared/models/mock-data";
// import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: "app-region",
  templateUrl: "./region.component.html",
  styleUrls: ["./region.component.scss"],
})
export class RegionComponent implements OnInit {
  addOrEditRegion: string;
  regions = [];
  title = "modal2";
  formGroup;
  deletePopupUiData;
  excel: ExcelModel = new ExcelModel();
  tempOptionModel: any;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public regionProviders: RegionProvider,
    public adminDataProvider: AdminDataProvider,
    private toast: ToastClientService,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService
  ) {}

  ngOnInit() {}

  ngDoCheck() {
    this.regions = this.regionProviders.regions;
    if (this.regionProviders.actionSuccess == true) {
      this.modalService.dismissAll();
    }
  }

  addRegion(targetModal) {
    this.regionProviders.actionSuccess = false;
    this.addOrEditRegion = "edit";
    this.formGroup = this.fb.group({
      region_name: new FormControl("", [Validators.required]),
      program_id: 1,
    });
    this.showRegionModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editRegion(targetModal, regionInfo) {
    this.regionProviders.actionSuccess = false;
    this.addOrEditRegion = "edit";
    this.formGroup = this.fb.group({
      region_name: new FormControl(regionInfo.region_name, [
        Validators.required,
      ]),
      region_id: regionInfo.id,
      program_id: 1,
    });
    this.showRegionModal(targetModal);
  }

  deleteRegion(targetModal, regionInfo) {
    this.regionProviders.actionSuccess = false;
    this.addOrEditRegion = "delete";
    this.deletePopupUiData = regionInfo.region_name;

    this.formGroup = this.fb.group({
      region_id: regionInfo.id,
      program_id: 1,
    });

    this.showRegionModal(targetModal);
  }

  showRegionModal(targetModal) {
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: "static",
    });
  }

  submitted = false;

  onSubmitRegion(formData) {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    let regionModel: RegionModel = formData as RegionModel;
    if (this.addOrEditRegion == "add") {
      this.regionProviders.regionAdd(regionModel);
    } else if (this.addOrEditRegion == "edit") {
      this.regionProviders.regionEdit(regionModel);
    } else if (this.addOrEditRegion == "delete") {
      this.regionProviders.regionDelete(regionModel);
    }
  }

  /**
   * @auth kailash_dev
   */
  /** Add new brands section */
  showuploadTemplateModal(targetModal) {
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel() {
    this.tempOptionModel.close();
  }
  uploadXlsx(eve) {
    this.xlsx.uploadXlsx(eve).then((res) => {
      this.xlsxView(res);
    });
  }
  xlsxView(data) {
    data.apiHeaders = REGION_UPLOAD_HEADER;
    this.closeoptionModel();
    let modalRef = this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: "static",
      size: "xl",
      scrollable: true,
      windowClass: "ExcelTemplateViewModal",
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then(
      (result) => {
        console.log("XlsxViewComponent::", result);
        if (result.length > 0) {
          this.excel.excel_data = result;
          this.importAllUsers(this.excel);
        }
      },
      (reason) => {}
    );
  }

  importAllUsers(data) {
    this.apiService.post(this.apiConfig.importExcelRegion, data).subscribe(
      (res: any) => {
        this.toast.Success("Data imported Successfully");
        this.regionProviders.getRegionList();
      },
      (err) => {
        this.toast.Error("Failed to Update");
        console.log(err);
      }
    );
  }

  downloadExcel() {
    this.exportExcelService.exportRegionExcel();
  }
}
